import { BaseContactsFiltersType } from "@/protocols/ClientCatalogFilterProtocol"
import ApiService from "@/services/Api"

class FilterService {
	async get (inboxChannelId?: number) {
		if (!inboxChannelId) {
			return null
		}

		const response = await ApiService.get(`/clients/contacts-filters/${inboxChannelId}`)

		return response.data
	}

	async post (createFilter: BaseContactsFiltersType): Promise<BaseContactsFiltersType> {
		const response = await ApiService.post("clients/contacts-filters", createFilter)

		return response.data.dataValues
	}

	async update (updatedFilters: BaseContactsFiltersType) {
		await ApiService.put("/clients/contacts-filters", updatedFilters)
	}

	async delete (filterId?: number, inboxChannelId?: number) {
		if (!filterId && !inboxChannelId) {
			return null
		}

		const response = await ApiService.delete(`/clients/contacts-filters/${filterId}`, { params: { inboxChannelId } })

		return response.data
	}
}

export default new FilterService()
